import React from "react";
import useOverview from "./useOverview";

export default (props) => {
  const { companyInfo } = useOverview();

  return (
    <div className="py-4 px-4 bg-grey-4 common-wrapper">
      <div className="overview-wrapper rounded-lg bg-grey-3 border">
        <div className="bg-grey-2">
          <h3 className="py-3 px-4">Company Description</h3>
        </div>
        <div className="p-4 bg-white text-grey-4">
          <p>{companyInfo?.about ? companyInfo?.about : "NA"}</p>
        </div>
      </div>
      <div className="overview-wrapper rounded-lg bg-grey-3 border mt-4">
        <div className="bg-grey-2">
          <h3 className="py-3 px-4">Company Information</h3>
        </div>
        <div className="p-4 bg-white row mx-0">
          <div className="col-md-4 mb-3">
            <p className="text-grey-4 mb-1">Website</p>
            <p className="font-weight-medium">
              {companyInfo?.url ? (
                <>
                  <a
                    href={companyInfo?.url}
                    className="text-underline"
                    target="_blank"
                  >
                    {companyInfo?.url}
                  </a>
                </>
              ) : (
                "NA"
              )}
            </p>
          </div>
          <div className="col-md-4 mb-3">
            <p className="text-grey-4 mb-1">Industry</p>
            <p className="font-weight-medium">
              {companyInfo?.industry ? companyInfo?.industry : "NA"}
            </p>
          </div>
          <div className="col-md-4 mb-3">
            <p className="text-grey-4 mb-1">Company Size</p>
            <p className="font-weight-medium">
              {companyInfo?.size ? <>{companyInfo?.size} Employees</> : "NA"}
            </p>
          </div>
          <div className="col-md-4">
            <p className="text-grey-4 mb-1">Phone Number</p>
            <p className="font-weight-medium">
              {companyInfo?.phone_number ? companyInfo?.phone_number : "NA"}
            </p>
          </div>
          <div className="col-md-4">
            <p className="text-grey-4 mb-1">Location</p>
            <p className="font-weight-medium">Alpharetta, GA</p>
          </div>
        </div>
      </div>
    </div>
  );
};
